// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dropzone[data-v-6b9f4212]{min-height:8px;padding:4px 10px;border-style:dotted solid}", ""]);
// Exports
module.exports = exports;
